import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58968561"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "landing-page-login-form" }
const _hoisted_2 = { class: "ava-logo-container" }
const _hoisted_3 = { class: "title-container" }
const _hoisted_4 = { class: "button-row" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" sign in ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("create an account")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_loader = _resolveComponent("base-loader")!
  const _component_authentication_pages_logo = _resolveComponent("authentication-pages-logo")!
  const _component_base_typography = _resolveComponent("base-typography")!
  const _component_email_and_password_inputs = _resolveComponent("email-and-password-inputs")!
  const _component_forgot_password_button = _resolveComponent("forgot-password-button")!
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_base_loader, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_authentication_pages_logo)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_base_typography, {
        heading1: "",
        class: "title"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.loginFormTitle), 1)
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_email_and_password_inputs, {
      tabIndexes: [1, 2],
      email: _ctx.email,
      "onUpdate:email": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
      password: _ctx.password,
      "onUpdate:password": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
      onSignIntoApp: _ctx.signIntoApp
    }, null, 8, ["email", "password", "onSignIntoApp"]),
    _createVNode(_component_forgot_password_button),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_base_button, {
        "data-testid": "submit-sign-in-button",
        primary: "",
        onClick: _ctx.signIntoApp
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_base_button, {
        tertiary: "",
        onClick: _ctx.goToSignUp
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}